import { BaseReducer } from '@hobs/utils/baseReducer';
import { GET, FOR_SUBMIT, RESET } from '@hobs/constants/transportation';

const TransportationShape = {
  forSubmit: {
    suppliers: [],
    transportTypes: [],
    transportationDetailsTypes: [],
    vehicleTypes: []
  },
  item: {
    lines: [],
    generalInformation: {},
    pickupDetails: {},
    deliveryDetails: {}
  }
};

class Transportation extends BaseReducer {
  static defaultState = TransportationShape;
  constructor() {
    super(Transportation.defaultState);

    this.actionMap = {
      [GET.SUCCESS]: this.addTransportation,
      [FOR_SUBMIT.SUCCESS]: this.addForSubmit,
      [RESET.SUCCESS]: this.resetForSubmit
    };
  }

  addTransportation = (state, action) => {
    return Object.assign({}, state, { item: action.response });
  };

  addForSubmit = (state, action) => {
    return Object.assign({}, state, { forSubmit: action.response });
  };

  resetForSubmit = state => {
    return Object.assign({}, state, TransportationShape);
  };
}

export default new Transportation().reducer;
